// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorPage__nWbLk {
  height: 100%;
  width: 100%;
  background-color: var(--tables-main-surface);
  position: relative;
}

.errorPageBgWrapper__Ghnzm {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-color: var(--tables-main-surface);
  z-index: 1;
}

.errorPageBgWrapperImage__IVHeW {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.errorPageBlock__wwr_s {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.errorIcon__AtREa .icon-bg {
  fill: var(--tables-main-surface);
  stroke: var(--buttons-surface);
  stroke-width: 3;
}
.errorIcon__AtREa .eye {
  fill: var(--buttons-surface);
}
.errorIcon__AtREa .mouth {
  stroke: var(--buttons-surface);
  stroke-width: 3;
}

.errorPageTitle__m3VHh {
  font-size: 24px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  margin-top: 45px;
  max-width: 480px;
}

.errorPageDesc__SS6WV {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: var(--tables-primary-row-text-additional);
  margin-top: 15px;
  max-width: 650px;
}
@media (max-width: 900px) {
  .errorPageDesc__SS6WV {
    max-width: 500px;
  }
}

.errorPageActions__ld3K_ {
  display: grid;
  grid-template-columns: repeat(1, 134px);
  column-gap: 20px;
  margin-top: 45px;
}

.errorPageSupportLink__OZgxN {
  color: var(--buttons-text-secondary);
}
.errorPageSupportLink__OZgxN:hover {
  color: var(--buttons-hover);
}
.errorPageSupportLink__OZgxN:active {
  color: var(--buttons-focused);
}`, "",{"version":3,"sources":["webpack://./../src/pages/Error404/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,WAAA;EACA,4CAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,4CAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AAzEF;;AA8EI;EACE,gCAAA;EACA,8BAAA;EACA,eAAA;AA3EN;AA6EI;EACE,4BAAA;AA3EN;AA8EI;EACE,8BAAA;EACA,eAAA;AA5EN;;AAiFA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA9EF;;AAiFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gDAAA;EACA,gBAAA;EACA,gBAAA;AA9EF;AAgFE;EATF;IAUI,gBAAA;EA7EF;AACF;;AAgFA;EACE,aAAA;EACA,uCAAA;EACA,gBAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,oCAAA;AA7EF;AA+EE;EACE,2BAAA;AA7EJ;AA+EE;EACE,6BAAA;AA7EJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.errorPage {\n  height: 100%;\n  width: 100%;\n  background-color: var(--tables-main-surface);\n  position: relative;\n}\n\n.errorPageBgWrapper {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  background-color: var(--tables-main-surface);\n  z-index: 1;\n}\n\n.errorPageBgWrapperImage {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n.errorPageBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n}\n\n.errorIcon {\n  :global {\n    .icon-bg {\n      fill: var(--tables-main-surface);\n      stroke: var(--buttons-surface);\n      stroke-width: 3;\n    }\n    .eye {\n      fill: var(--buttons-surface);\n    }\n\n    .mouth {\n      stroke: var(--buttons-surface);\n      stroke-width: 3;\n    }\n  }\n}\n\n.errorPageTitle {\n  font-size: 24px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  margin-top: 45px;\n  max-width: 480px;\n}\n\n.errorPageDesc {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 15px;\n  max-width: 650px;\n\n  @media (max-width: 900px) {\n    max-width: 500px;\n  }\n}\n\n.errorPageActions {\n  display: grid;\n  grid-template-columns: repeat(1, 134px);\n  column-gap: 20px;\n  margin-top: 45px;\n}\n\n.errorPageSupportLink {\n  color: var(--buttons-text-secondary);\n\n  &:hover {\n    color: var(--buttons-hover);\n  }\n  &:active {\n    color: var(--buttons-focused);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPage": `errorPage__nWbLk`,
	"errorPageBgWrapper": `errorPageBgWrapper__Ghnzm`,
	"errorPageBgWrapperImage": `errorPageBgWrapperImage__IVHeW`,
	"errorPageBlock": `errorPageBlock__wwr_s`,
	"errorIcon": `errorIcon__AtREa`,
	"errorPageTitle": `errorPageTitle__m3VHh`,
	"errorPageDesc": `errorPageDesc__SS6WV`,
	"errorPageActions": `errorPageActions__ld3K_`,
	"errorPageSupportLink": `errorPageSupportLink__OZgxN`
};
module.exports = ___CSS_LOADER_EXPORT___;
